export default __webpack_public_path__ + "static/media/petbud.a8f9d432.png";